<template>
  <div id="app">
    <div v-if="hideWrapper">
      <div class="container-fluid extended">
        <div class="row extended" id="content-body">
          <div
            v-bind:class="{ hidden: !finished, 'col-12': true, extended: true }"
          >
            <router-view @childInitialized="childInitialized"></router-view>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="container">
        <div class="row align-items-center pt-md-2">
          <div
            class="col-12 p-0 d-flex flex-column align-items-start gap-4 justify-content-start"
          >
            <div class="col-12 d-flex p-0 flex-row align-items-center justify-content-center">
              <div class="col-auto p-0" id="logo-bar">
              <nav class="inline-nav">
                <button class="hamburger-button" @click="toggleMobileMenu" :class="{ 'active': isMobileMenuOpen }">
                  <span></span>
                  <span></span>
                  <span></span>
                </button>

                <ul class="nav-list" :class="{ 'mobile-menu-open': isMobileMenuOpen }">
                  <li><a href="https://woonmatchkopnh.nl/">HOME</a></li>
                  <li><a href="/inschrijven">INSCHRIJVEN</a></li>
                  <li class="dropdown" :class="{ open: isWerkwijzeOpen }">
                    <a href="#" @click.prevent="toggleWerkwijze">WERKWIJZE</a>
                    <ul
                      v-show="isWerkwijzeOpen"
                      class="dropdown-list"
                      @click.stop
                    >
                      <li>
                        <a
                          href="https://woonmatchkopnh.nl/pagina/werkwijze-beter-wonen"
                          >WONINGBOUWVERENIGING BETER WONEN</a
                        >
                      </li>
                      <li>
                        <a
                          href="https://woonmatchkopnh.nl/pagina/werkwijze-woningstichting-anna-paulowna"
                          >WONINGSTICHTING ANNA PAULOWNA</a
                        >
                      </li>
                      <li>
                        <a
                          href="https://woonmatchkopnh.nl/pagina/wst-den-helder-en-helder-vastgoed-bv-wijzen-toe-o-b-v-reacties-op-de-geadverteerde-woningen"
                          >WONINGSTICHTING DEN HELDER EN HELDER VASTGOED</a
                        >
                      </li>
                      <li>
                        <a
                          href="https://woonmatchkopnh.nl/pagina/werkwijze-wooncompagnie"
                          >WOONCOMPAGNIE</a
                        >
                      </li>
                      <li>
                        <a
                          href="https://woonmatchkopnh.nl/pagina/werkwijze-woonzorg-nederland"
                          >WOONZORG</a
                        >
                      </li>
                    </ul>
                  </li>
                  <li>
                    <a href="https://woonmatchkopnh.nl/faq"
                      >VEELGESTELDE VRAGEN</a
                    >
                  </li>
                  <li>
                    <a href="https://woonmatchkopnh.nl/pagina/ruil-mijn-woning"
                      >RUIL MIJN WONING</a
                    >
                  </li>
                  <li>
                    <a href="https://woonmatchkopnh.nl/pagina/verantwoording"
                      >VERANTWOORDING</a
                    >
                  </li>
                  <li>
                    <a href="https://woonmatchkopnh.nl/pagina/contact"
                      >CONTACT</a
                    >
                  </li>
                </ul>
              </nav>
            </div>
            </div>

            <div id="logo" @click="logoClick" class="pointer">
              <img :src="this.skin.logo" :alt="`Logo van ${skin.region}`" />
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div
          class="row"
          id="banner"
          :style="`background-image: url('${this.skin.header}');`"
        >
          <div class="col-12">&nbsp;</div>
        </div>
        <div class="row" id="title-banner">
          <div class="col-12 text-center">
            <h1>
              {{ title }}
            </h1>
          </div>
        </div>
      </div>
      <div class="container">
        <!-- Papy Commented To remove read loud-->
        <!--
                <div v-if="skin.readspeaker.active" class="row">
                  <div class="col-12">
                    <div id="readspeaker">
                      <div id="readspeaker_button1" class="rs_skip rsbtn rs_preserve">
                        <a rel="nofollow" class="rsbtn_play" accesskey="L" title="Laat de tekst voorlezen met ReadSpeaker webReader" :href="`//app-eu.readspeaker.com/cgi-bin/rsent?customerid=${skin.readspeaker.code}&amp;lang=nl_nl&amp;readid=inner`">
                          <span class="rsbtn_left rsimg rspart"><span class="rsbtn_text"><span>Lees voor</span></span></span>
                          <span class="rsbtn_right rsimg rsplay rspart"></span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                -->
        <!--<navbar :key="navKey"></navbar>-->
        <div class="row" id="content-body">
          <div v-bind:class="{ hidden: !finished, 'col-12': true }">
            <router-view @childInitialized="childInitialized"></router-view>
          </div>
        </div>
      </div>
      <div class="container-fluid d-none d-lg-block" id="footer">
        <div class="row">
          <div class="col-12 text-center">
            <h2>Heeft u een vraag?</h2>
          </div>
        </div>
        <div class="row">
          <br />
        </div>
        <div class="row">
          <div class="col-12 col-lg-3 offset-lg-3 text-left footer-info-block">
            <ul class="list-unstyled">
              <li>
                <a href="../faq">
                  <i class="fa fax fa-question"></i>
                  <span>Kijk in veelgestelde vragen</span>
                </a>
              </li>
              <li>
                <a :href="`mailto:${skin.contactmail}`">
                  <i class="fa fax fa-envelope"></i>
                  <span>Stuur ons een e-mail</span>
                </a>
              </li>
            </ul>
          </div>
          <div class="col-12 col-lg-3 offset-lg-1 text-left footer-info-block">
            <ul class="list-unstyled">
              <li>
                <a :href="`tel:${skin.contactphone}`">
                  <i class="fa fax fa-phone"></i> <span>Bel gerust</span>
                </a>
              </li>
              <!--<li>
                                <i class="fa  fax fa-newspaper"></i> <span>Ik wil een nieuwsbrief ontvangen</span>
                            </li>-->
            </ul>
          </div>
        </div>
        <div class="row">
          <hr />
        </div>
        <div class="row flex-footer">
          <div class="col-12 col-lg-3">
            <h2>Andere diensten?</h2>
            <ul class="list-unstyled">
              <li>
                <a href="https://ruilmijnwoning.nl" target="_blank">
                  Woningruil
                </a>
              </li>
              <!--<li>
                                Urgentie
                            </li>
                            <li>
                                Doorstromers
                            </li>-->
            </ul>
          </div>
          <div class="col-12 col-lg-3" v-if="skin.app === true">
            <h2>Download de App</h2>
            <ul class="list-unstyled list-inline appstore">
              <li class="list-inline-item text-center">
                <a
                  href="https://play.google.com/store/apps/details?id=nl.woonmatch.app.twa"
                  target="_blank"
                >
                  <i class="fab fax fa-android"></i>
                  <p>Android</p>
                </a>
              </li>
              <li class="list-inline-item text-center">
                <a
                  href="https://apps.apple.com/nl/app/woonmatch-app/id1521635724"
                  target="_blank"
                >
                  <i class="fab fax fa-apple"></i>
                  <p>Apple</p>
                </a>
              </li>
            </ul>
          </div>
          <div class="col-12 col-lg-3">
            <h2>Over ons</h2>
            <ul class="list-unstyled">
              <li>
                <a href="../pagina/contact">
                  <span v-if="skin.plural"> De corporaties </span>
                  <span v-else>
                    {{ skin.region }}
                  </span>
                </a>
              </li>
              <li>
                <a href="../pagina/contact"> Contact </a>
              </li>
              <li>
                <a href="../pagina/informatie"> Informatie </a>
              </li>
            </ul>
          </div>
          <div class="col-12 col-lg-3">
            <h2>{{ skin.region }}</h2>
            <p>
              {{ skin.infotext }}
            </p>
          </div>
        </div>
      </div>

      <div class="container-fluid d-block d-lg-none" id="footer-mobile">
        <div class="row">
          <div class="col-12 text-center">
            <h2>Heeft u een vraag aan ons?</h2>
          </div>
        </div>
        <div class="row">
          <br />
        </div>
        <div class="row">
          <div class="col-12 text-left footer-info-block">
            <ul class="list-unstyled">
              <li>
                <i class="fa fax fa-question"></i>
                <a href="../faq">
                  <span>Staat het antwoord in de kennisbank?</span>
                </a>
              </li>
              <li>
                <i class="fad fax fa-envelope"></i>
                <a :href="`mailto:${skin.contactmail}`">
                  <span>Stuur ons een e-mail</span>
                </a>
              </li>
            </ul>
            <ul class="list-unstyled">
              <li>
                <i class="fad fax fa-phone"></i>
                <a :href="`tel:${skin.contactphone}`">
                  <span>Neem gerust contact met ons op</span>
                </a>
              </li>
              <!--<li>
                                <i class="fad fax fa-newspaper"></i> <span>Ik wil de nieuwsbrief</span>
                            </li>-->
            </ul>
          </div>
        </div>
        <div class="row">
          <hr />
        </div>
        <div class="row" v-if="skin.app === true">
          <div class="col-12 text-center">
            <h2>Download de App</h2>
            <ul class="list-unstyled list-inline appstore">
              <li class="list-inline-item text-center">
                <i class="fab fax fa-android"></i>
                <p>Android</p>
              </li>
              <li class="list-inline-item text-center">
                <i class="fab fax fa-apple"></i>
                <p>Apple</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./components/Navbar";
export default {
  name: "app",
  components: { Navbar },
  data: () => {
    return {
      navKey: 0,
      finished: false,
      hideWrapper: false,
      title: "Bezig met laden...",
      isWerkwijzeOpen: false,
      isMobileMenuOpen: false,
      skin: {
        logo: process.env.VUE_APP_LOGO,
        header: process.env.VUE_APP_HEADER,
        region: process.env.VUE_APP_REGION,
        plural: process.env.VUE_APP_PLURAL === "true",
        infotext: process.env.VUE_APP_INFOTEXT,
        contactmail: process.env.VUE_APP_CONTACTMAIL,
        contactphone: process.env.VUE_APP_CONTACTPHONE,
        readspeaker: {
          active: process.env.VUE_APP_READSPEAKER === undefined ? false : true,
          code: process.env.VUE_APP_READSPEAKER,
        },
        app: process.env.VUE_APP_HASMOBILE,
      },
    };
  },
  watch: {
    $route() {
      // clear alert on location change
      this.navKey++;
      this.isWerkwijzeOpen = false;
      this.isMobileMenuOpen = false;
    },
  },
  methods: {
    childInitialized(data) {
      this.title = data.title;
      this.finished = true;
    },
    logoClick() {
      // const loggedIn = this.$store.state.authentication.status.loggedIn;
      // const aanbod = "../woningaanbod";

      // if (loggedIn) {
      //   window.location.href = "https://woonmatchkopnh.nl/";
      //   return;
      // }

      // const isNewUser = this.$store.state.registration.newUser === true;
      // if (!isNewUser && this.$route.path !== aanbod) {
      //   this.$router.push(aanbod);
      // }
      window.location.href = "https://woonmatchkopnh.nl/";
    },
    toggleWerkwijze() {
      if (this.isWerkwijzeOpen) {
        this.isWerkwijzeOpen = false;
        window.location.href =
          "https://woonmatchkopnh.nl/pagina/werkwijze-bij-woningtoewijzing-bij-de-verschillende-corporaties";
      } else {
        this.isWerkwijzeOpen = true;
      }
    },

    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },

    closeWerkwijze(event) {
      if (!event.target.closest(".dropdown")) {
        this.isWerkwijzeOpen = false;
      }
    },
  },
  mounted() {
    this.hideWrapper = this.$route.meta.hideWrapper || false;

    document.addEventListener("click", this.closeWerkwijze);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.closeWerkwijze);
  },
};
</script>

<style scoped>
.extended {
  margin: 0px;
  padding: 0px;
}
@media (max-width: 576px) {
  #banner {
    max-height: 70px;
  }
  #title-banner {
    max-height: 50px;
  }
  #title-banner h1 {
    line-height: 50px;
    font-size: 23px;
  }
}
.flex-footer {
  display: flex;
  justify-content: center;
}

#logo-bar {
  background-color: #f29100;
  color: #fff;
  opacity: .70;
  display: flex;
  justify-content: center;
}

#logo img {
  max-height: 120px;
}

.inline-nav .nav-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.nav-list > li {
  padding: 4px 0px;
  line-height: 1;
}

.nav-list .dropdown {
  position: relative;
}

.nav-list .dropdown-list {
  display: none;
  position: absolute;
  top: calc(100% + 10px);
  left: 0;
  background-color: #f29100;
  opacity: 0.9;
  list-style: none;
  padding: 0;
  padding-top: 20px;
  margin: 0;
  flex-direction: column;
  z-index: 1000;
  white-space: nowrap;
  min-width: 250px;
}

.nav-list .dropdown.open .dropdown-list,
.nav-list .dropdown-list[style*="display: block"] {
  display: flex;
  align-items: stretch;
  margin-left: -30px;
}

.nav-list .dropdown.open > a {
  border-right-color: #007bff !important;
}

.inline-nav .nav-list li + li:last-child {
  margin-right: 0 !important;
}

.dropdown-list li + li {
  margin-left: 0 !important;
}

.inline-nav .nav-list a,
.inline-nav .nav-list a:visited,
.inline-nav .nav-list a:hover,
.inline-nav .nav-list a:focus,
.inline-nav .nav-list a:active {
  color: #fff !important;
  font-size: 14px !important;
  text-align: center;
  text-decoration: none !important;
  padding: 2px 16px 0px;
  border-right: 2px solid #fff;
}

.inline-nav .nav-list > li:last-child > a {
  border-right: none;
}

.inline-nav .nav-list a:hover,
.inline-nav .nav-list a:focus,
.inline-nav .nav-list a:active {
  text-decoration: underline;
}

.align-items-center {
  align-items: center !important;
}

.dropdown-list li {
  margin: 0;
  line-height: 1.2;
}

.dropdown-list li a {
  display: block;
  padding: 8px 16px;
  margin: 0;
  font-size: 14px;
  font-weight: normal;
  border-right: none !important;
}

.hamburger-button {
  display: none;
  position: relative;
  flex-direction: column;
  justify-content: space-around;
  width: 30px;
  height: 30px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 1010;
}

.hamburger-button span {
  width: 100%;
  height: 3px;
  background-color: white;
  border-radius: 2px;
  transition: all 0.3s ease-in-out;
  position: relative;
  transform-origin: center;
}

.hamburger-button.active span:nth-child(1) {
  transform: translateY(9px) rotate(45deg);
}

.hamburger-button.active span:nth-child(2) {
  opacity: 0;
}

.hamburger-button.active span:nth-child(3) {
  transform: translateY(-9px) rotate(-45deg);
}

@media (max-width: 768px) {
  #logo-bar {
    width: 100%;
    justify-content: flex-end;
    padding: 8px;
    background-color: #f29100;
    opacity: 1 !important;
  }

  .hamburger-button {
    display: flex;
  }

  .hamburger-button span {
    width: 100%;
    height: 2px;
    background-color: white;
    border-radius: 2px;
  }

  .inline-nav {
    padding: 0.5rem 1rem;
  }

  .inline-nav .nav-list {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    padding-top: 60px;
    background-color: #f29100;
    flex-direction: column;
    align-items: flex-start;
    flex-wrap: nowrap;
    z-index: 1000;
  }

  .inline-nav .nav-list.mobile-menu-open {
    display: flex;
  }

  .nav-list > li {
    width: 100%;
  }

  .inline-nav .nav-list a {
    border-right: none;
    text-align: left;
    width: 100%;
  }

  .inline-nav .nav-list > li:last-child > a {
    border-bottom: none;
  }

  .nav-list .dropdown-list {
    position: static;
    display: block;
    background-color: transparent;
    padding-left: 20px;
    min-width: auto;
    border-radius: 0;
  }

  .dropdown-list li a {
    padding: 8px 16px;
    font-size: 13px !important;
    border-bottom: none;
  }
}
</style>
